<div *ngIf="order$ | async as order"
     class="mb-submit-order-wrapper"
     data-cy="mb-submit-order-wrapper">
  <mb-submit-order-request *ngIf="!isPurchaseCheckout"
                           [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, order)"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_MIX, order)"
                           [totalPrice]="order?.totalPrice">
  </mb-submit-order-request>
  <mb-submit-order-price *ngIf="isPurchaseCheckout"
                         [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_AVAILABLE, order)"
                         [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, order)"
                         [totalPrice]="order?.totalPrice"
                         [showShippingTaxes]="true"
                         [prices]="order"
                         [shouldDisplayErpPrices]="true">
  </mb-submit-order-price>
  <div class="row no-gutters mt-2 pt-3 mb-submit-order-totals"
       data-cy="mb-submit-order-totals">
    <ng-container *ngIf="isPurchaseCheckout">
      <div class="col-4"
           data-cy="mb-submit-order-title" [innerHTML]="'submitBox.orderTotal' | cxTranslate | safeHtml">
      </div>
      <div class="col-8 text-right"
           data-cy="mb-submit-order-price">
        <span>
          <span *ngIf="order?.erpPricingError || (!order.erpTotalPrice?.formattedValue && !order.erpTotalListPrice?.formattedValue)">{{'submitBox.orderConfirmation' | cxTranslate}}</span>
          <strong *ngIf="!order?.erpPricingError && order.erpTotalPrice?.formattedValue" [innerHTML]="order?.erpTotalPrice?.formattedValue | safeHtml"></strong>
          <strong *ngIf="!order?.erpPricingError && !order.erpTotalPrice?.formattedValue && order.erpTotalListPrice?.formattedValue" [innerHTML]="order?.erpTotalListPrice?.formattedValue | safeHtml"></strong>
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="!isPurchaseCheckout">
      <div class="col-12 mb-request-info"
           data-cy="mb-submit-order-step-info"
           [innerHTML]="'submitBox.requestInfo' | cxTranslate">
      </div>
    </ng-container>
  </div>
</div>
